import React, { useContext } from "react";
import { ReactComponent as VisibilityIcon } from 'assets/icons/Visibility.svg';
import { ReactComponent as RefreshIcon } from 'assets/icons/Refresh.svg';
import { SvgIcon } from "@mui/material";
import { NormalizerContext } from "../NormalizerContext";
import { normalizerHooks } from "..";
import { isEmpty } from 'lodash';

const useHeaderBtns = () => {
    const { assessmentFilters, activeScoreItemStatus, stats } = useContext(NormalizerContext)
    const viewUpdatedScoreRating = normalizerHooks.useViewUpdatedScoreRating()
    const applyScoreRating = normalizerHooks.useApplyScoreRating()
    const initScoreRating = normalizerHooks.useInitScoreRating()

    const headerBtns = React.useMemo(
        () =>
            [
                {
                    label: "אפס תצוגת שינויים",
                    action: initScoreRating,
                    icon: <SvgIcon fontSize="small" component={RefreshIcon} inheritViewBox />,
                    size: "small",
                    disabled: !activeScoreItemStatus
                },
                {
                    label: "תצוגת שינויים",
                    action: viewUpdatedScoreRating,
                    icon: <SvgIcon fontSize="small" component={VisibilityIcon} inheritViewBox />,
                    size: "small",
                    disabled: activeScoreItemStatus != "edit" ||
                        (
                            assessmentFilters.methods.length > 1 ||
                            !isEmpty(assessmentFilters.semester) ||
                            !isEmpty(assessmentFilters.grade_of_execution)
                        )
                },
                {
                    label: "החל נתונים חדשים בDATA",
                    action: applyScoreRating.action,
                    loading: applyScoreRating.isPending,
                    disabled:
                        //אנחנו לא מאפשרים ללחוץ על החל לפני שסיימנו להציג את יראו הגרפים לאחר השינוי
                        activeScoreItemStatus != "view" ||
                        //Can apply socre changes only if it is go method
                        (assessmentFilters.methods?.length > 1 || assessmentFilters.methods?.[0]?.id != 2),
                    size: "small"
                }
            ],
        [activeScoreItemStatus, assessmentFilters, stats]
    );


    return headerBtns
}

export default useHeaderBtns